import axios from "axios";
import ConnUrls from '../ConnectURL'


const getMaster = async () => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "master");
    return (dFromF);
}


const getMainMenu = async () => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "master/getMainMenu");
    return (dFromF);
}

export default {
    getMaster,
    getMainMenu
};